export default __webpack_public_path__ + "static/mascot_welcome_logo-89902d0b297b15a1d3cb00871c7d4062.png";